module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.cItems), function(item, index) {
    return _c('div', {
      key: item.key,
      staticClass: " weex-ct weex-div",
      attrs: {
        "accessible": true,
        "aria-label": ((item.title) + "," + (item.desc?item.desc:'') + "," + (item.date?item.date:'') + "," + (item.highlight?'已完成':'等待完成')),
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "title flex-row weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "line weex-ct weex-div",
      class: item.__titleLineClass__,
      style: (_vm._px2rem(item.__lineStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "point weex-ct weex-div",
      class: item.__pointClass__,
      style: (_vm._px2rem(item.__pointStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-title full-rest weex-el weex-text",
      class: item.__titleTextClass__,
      style: (_vm._processExclusiveStyle(item.__titleStyle__, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content flex-row weex-ct weex-div",
      class: item.__contentClass__,
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "line weex-ct weex-div",
      class: item.__contentLineClass__,
      style: (_vm._px2rem(item.__lineStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-rest weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(item.desc) ? _c('p', {
      staticClass: "text-desc weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e(), _vm._v(" "), (item.date) ? _c('p', {
      staticClass: "text-date weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.date))]) : _vm._e()])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e059b070", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e059b070","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-simple-flow/index.vue
// module id = 245
// module chunks = 0 1